import { createSvgIcon } from '@mui/material/utils';
import React, { memo } from 'react';
const SvgIcon = createSvgIcon([
    React.createElement("polygon", { key: '0', fill: '#00B90F', points: '22,22.8 2,22.8 12,2.8 ' }),
    React.createElement("path", { key: '1', fill: '#000000', d: 'M12,0.6L0.4,23.8h23.2L12,0.6z M3.6,21.8L12,5.1l8.4,16.7H3.6z' }),
], 'TransportConditionSpeed');
const TransportTriangleIcon = function (props) {
    return (React.createElement(SvgIcon, Object.assign({ sx: {
            polygon: {
                fill: props.color,
            },
        } }, props)));
};
export default memo(TransportTriangleIcon);
